import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BikeRentalPage.css"; // reuse same CSS

import { useEffect } from "react";

import RoyalEnfield from "../../assets/RoyalEnfield.png";
import KTM from "../../assets/KTM.png";
import Pulsar from "../../assets/Pulsar.png";
import Activa from "../../assets/Activa.png";

// 🔹 BIKE DATA
const bikeData = {
  Sports: [
    {
      name: "KTM Duke",
      fuels: ["Petrol"],
      image: KTM,
    },
    {
      name: "Pulsar 220",
      fuels: ["Petrol"],
      image: Pulsar,
    },
  ],
  Cruiser: [
    {
      name: "Royal Enfield Classic",
      fuels: ["Petrol"],
      image: RoyalEnfield,
    },
  ],
  Scooter: [
    {
      name: "Honda Activa",
      fuels: ["Petrol"],
      image: Activa,
    },
  ],
};

// 🔹 GENERATE ALL CARDS
const generateAllCards = () => {
  let cards = [];
  let id = 0;

  Object.keys(bikeData).forEach((type) => {
    bikeData[type].forEach((model) => {
      model.fuels.forEach((fuel) => {
        cards.push({
          id: id++,
          name: model.name,
          type,
          fuel,
          image: model.image,
          price: 500,
          distance: ["0-50km", "51-100km", "101-200km"][
            Math.floor(Math.random() * 3)
          ],
          rating: (4 + Math.random()).toFixed(1),
        });
      });
    });
  });

  return cards;
};

const BikeRentalPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [distance, setDistance] = useState("");
  const [priceSort, setPriceSort] = useState("");

  const [bikeType, setBikeType] = useState("");
  const [bikeModel, setBikeModel] = useState("");
  const [fuelType, setFuelType] = useState("");

  let tripData = location.state;

  // 🔥 fallback
  if (!tripData) {
    const saved = localStorage.getItem("tripData");
    tripData = saved ? JSON.parse(saved) : null;
  }



useEffect(() => {
  if (!tripData) {
    alert("Please fill booking details first");
    navigate("/");
  }
}, [tripData, navigate]);

if (!tripData) return null;


  const models = bikeType ? bikeData[bikeType] : [];
  const selectedModel = models.find((m) => m.name === bikeModel);
  const fuels = selectedModel?.fuels || [];

  let cards = [];

  // 🔹 FILTERED CARDS
  if (bikeType && bikeModel && fuelType) {
    cards = [
      {
        id: 1,
        name: bikeModel,
        type: bikeType,
        fuel: fuelType,
        image: selectedModel?.image,
        price: 500,
        distance: distance || "0-50km",
        rating: 4.5,
      },
    ];
  } else {
    cards = generateAllCards();
  }

  let filteredCards = cards.filter((b) => !distance || b.distance === distance);

  if (priceSort === "low-high") {
    filteredCards.sort((a, b) => a.price - b.price);
  } else if (priceSort === "high-low") {
    filteredCards.sort((a, b) => b.price - a.price);
  }

  // 🔹 SELECT BIKE
  const handleSelectBike = (bike) => {
    const bookingData = {
      vehicle: "bike",
      bikeData: bike,

      extraCharges: 100,
      fuelCharges: 150,

      pickup: tripData?.pickup,
      drop: tripData?.drop,
      bookingDate: tripData?.date,
      bookingTime: tripData?.time,
    };

    localStorage.setItem("bookingData", JSON.stringify(bookingData));

    navigate("/bike-rental-detail-page", {
      state: bookingData,
    });
  };

  return (
    <div className="container">
      <h2>Book Your Bike</h2>

      {/* 🔹 FILTERS */}
      <div className="dropdowns">
        <select onChange={(e) => setDistance(e.target.value)}>
          <option value="">Distance</option>
          <option>0-50km</option>
          <option>51-100km</option>
          <option>101-200km</option>
          <option>201-300km</option>
        </select>

        <select onChange={(e) => setPriceSort(e.target.value)}>
          <option value="">Price</option>
          <option value="low-high">Low → High</option>
          <option value="high-low">High → Low</option>
        </select>

        <select
          value={bikeType}
          onChange={(e) => {
            setBikeType(e.target.value);
            setBikeModel("");
            setFuelType("");
          }}
        >
          <option value="">Bike Type</option>
          {Object.keys(bikeData).map((type) => (
            <option key={type}>{type}</option>
          ))}
        </select>

        <select
          value={bikeModel}
          onChange={(e) => {
            setBikeModel(e.target.value);
            setFuelType("");
          }}
          disabled={!bikeType}
        >
          <option value="">Bike Model</option>
          {models.map((m) => (
            <option key={m.name}>{m.name}</option>
          ))}
        </select>

        <select
          value={fuelType}
          onChange={(e) => setFuelType(e.target.value)}
          disabled={!bikeModel}
        >
          <option value="">Fuel Type</option>
          {fuels.map((f) => (
            <option key={f}>{f}</option>
          ))}
        </select>
      </div>

      {/* 🔹 CARDS */}
      <div className="card-container">
        {filteredCards.map((bike) => (
          <div className="car-card" key={bike.id}>
            <div className="card-image">
              <img src={bike.image} alt="bike" />
              <span className="fuel-tag">{bike.fuel}</span>
            </div>

            <div className="card-content">
              <h2 className="car-title">{bike.name.toUpperCase()}</h2>
              <p className="car-sub">{bike.type} • 2 Seater</p>

              <div className="price-row">
                <div>
                  <span className="old-price">₹800</span>
                  <h3 className="new-price">
                    ₹{bike.price}
                    <span>/day</span>
                  </h3>
                </div>

                <button
                  className="view-btn"
                  onClick={() => handleSelectBike(bike)}
                >
                  VIEW MORE
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BikeRentalPage;
